import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  getPublicCefrV1ResponseSchema,
  type IPublicCefrV1Data,
} from './get-public-cefr-v1-response';

export async function getPublicCefrV1Api(level: string) {
  return getRequest<IAPI<IPublicCefrV1Data>>({
    path: `/challenges/cefr/${encodeURIComponent(level)}/v1`,
    schema: getPublicCefrV1ResponseSchema,
  });
}
